import Header from '../components/Header';
import Footer from '../components/Footer';

const FMALPerth = () => {
}

export default FMALPerth;